"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IMPORT_EXTERNAL_BLOG = void 0;

var _SimpleStagedObject = _interopRequireDefault(require("redux-less/SimpleStagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _constants = require("settings-ui-sdk/Blogs/constants");

var IMPORT_EXTERNAL_BLOG = 'importExternalBlog';
exports.IMPORT_EXTERNAL_BLOG = IMPORT_EXTERNAL_BLOG;
var NEW_BLOG = 'NewBlog';
var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.NAME,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.DOMAIN,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.SLUG,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: IMPORT_EXTERNAL_BLOG,
  initialValue: false
}];
var CreateNewBlog = new _SimpleStagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.website.blogs.staging.newBlog;
  },
  properties: properties,
  objectType: NEW_BLOG,
  namespace: 'blogs'
});
var _default = CreateNewBlog;
exports.default = _default;